;(function($, window, document){
    window.FaqTitle = Me.view.extend({
        options: {

        },
        initialize: function() {
            _.bindAll(this, 'scrollToElement');
            this.addEvents();

        },
        addEvents: function() {
            Me.dispatch.subscribe('faq.scroll', this.scrollToElement);
        },
        scrollToElement: function(e, params){
            if(this.$('h3').attr('data-anchor') == params.anchor){
                $("html, body").animate({ scrollTop: this.$el.offset().top - 100 });
            }
        }
    });
}(jQuery, window, document));
